<ng-content></ng-content>
<ng-content select="label"></ng-content>
<ng-content select="[etAtomsSelectError]"></ng-content>
